import env from './env'

export default {
  baseURL: env.baseURL,
  clientId: Number(process.env.REACT_APP_CLIENT_ID) || 1,
  clientSecret: process.env.REACT_APP_CLIENT_SECRET || '',
  grantType: 'password',
  namespace: 'iptu',
}
